import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useIsBetaVendor } from "@/entities/plan";

/**
 * Beta vendors (open-ended STARTER trial) have no billing to manage — every
 * entry point (sidebar item, header plan badge) is hidden for them, and this
 * guard covers the last path in: a typed or bookmarked /store/:storeId/billing
 * URL redirects to the dashboard. While the plan query is still loading the
 * page renders normally (it has its own skeletons, and the fingerprint fails
 * open), so normal vendors see zero difference; the redirect kicks in the
 * moment the beta fingerprint is confirmed.
 */
export default function BetaBillingGuard({
  children,
}: {
  children: ReactNode;
}) {
  const { isBeta } = useIsBetaVendor();
  const { storeId } = useParams();

  if (isBeta) {
    return <Navigate to={storeId ? `/store/${storeId}` : "/"} replace />;
  }
  return <>{children}</>;
}
